export default function NotFoundPage() {
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <h1 className="text-center font-tusker text-7xl font-extrabold">404</h1>
      <h4 className="mt-8 font-roobert text-3xl font-extrabold">
        Page not found
      </h4>
      <p className="mt-4 font-roobert">
        The page you are looking for is not available!
      </p>
    </div>
  )
}
